import axios from "axios";
// import { baseURL } from "./init.js";
const baseURL='https://api.aiworldcommunity.com/admin/api'

// Login user with credentials
async function loginUser(credentials) {
  try {
    const response = await axios.post(`${baseURL}/auth/login`, credentials);  
    return response.data;
  } catch (error) {
    return {
      state:'error',
      message:'Could not log you in, try again'
    }
  }
}

// Logout user by ID
async function logoutUser(id) {
  try {
    const response = await axios.get(`${baseURL}/auth/logout/${id}`);
    return response.data;
  } catch (error) {
    return {state:'error',message:'Logout failed' };
  }
}

export { loginUser,logoutUser };